import { trackPageLoad } from '@fff-web/fff-analytics';
import { PricesProvider } from '@fff-web/fff-payments';
import { ReactivateMyMembershipProvider } from '../../utils/ContextProviders/ReactivateContext';
import { ReactivatePlanDataProvider } from '../../utils/ContextProviders/ReactivatePlanDataContext';
import {
  COUPON_CODE_QUERY_PARAM,
  EXPIRED_SUBSCRIPTION_STATE,
  LOGGED_OUT_STATE,
} from '../constants';
import { getQueryParam } from '../MyAccount/utils/url';
import ReactivateMembership from './ReactivateMembershipContainer';

const ReactivateMyMembership = () => {
  trackPageLoad({
    properties: {
      coupon_code: getQueryParam(COUPON_CODE_QUERY_PARAM),
      subscription_state: EXPIRED_SUBSCRIPTION_STATE,
      login_state: LOGGED_OUT_STATE,
    },
  });
  return (
    <ReactivateMyMembershipProvider>
      <PricesProvider>
        <ReactivatePlanDataProvider>
          <ReactivateMembership />
        </ReactivatePlanDataProvider>
      </PricesProvider>
    </ReactivateMyMembershipProvider>
  );
};

export default ReactivateMyMembership;
